import { render, staticRenderFns } from "./DialogIA.vue?vue&type=template&id=cee24f9e&scoped=true&"
import script from "./DialogIA.vue?vue&type=script&lang=js&"
export * from "./DialogIA.vue?vue&type=script&lang=js&"
import style0 from "./DialogIA.vue?vue&type=style&index=0&id=cee24f9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee24f9e",
  null
  
)

export default component.exports